module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.ee10db2f.png";